import { Injectable } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';

@Injectable({
  providedIn: 'root'
})
export class SpinnerService {

  disabled = false;
  private spinnerStartTime: number = 0;
  private hideTimeout: any = null;
  private readonly minimumDisplayTime = 1000; 

  constructor(private spinner: NgxSpinnerService) { }
  
  showSpinner() {
    // Clear any pending hide timeout to avoid conflicts
    if (this.hideTimeout) {
      clearTimeout(this.hideTimeout);
      this.hideTimeout = null;
    }
    
    this.spinnerStartTime = performance.now(); // More precise than Date.now()
    this.spinner.show('upsSpinner', {
      type: 'custom',
      size: 'medium',
      bdColor: 'rgba(255, 255, 255, 0.8)',
      color: '#321815',
      template: '<app-spinner></app-spinner>'
    });
  }
  
  hideSpinner() {
    const elapsedTime = performance.now() - this.spinnerStartTime;
    const remainingTime = this.minimumDisplayTime - elapsedTime;
    
    if (remainingTime > 0) {
      // Use requestAnimationFrame for better performance than setTimeout
      this.hideTimeout = setTimeout(() => {
        this.spinner.hide('upsSpinner');
        this.hideTimeout = null;
      }, remainingTime);
    } else {
      // Hide immediately - no delay
      this.spinner.hide('upsSpinner');
    }
  }
  
  // Emergency hide method - bypasses minimum display time
  hideSpinnerImmediately() {
    if (this.hideTimeout) {
      clearTimeout(this.hideTimeout);
      this.hideTimeout = null;
    }
    this.spinner.hide('upsSpinner');
  }
  
  // show(className: any) {
  //   const spinner = document.querySelector(className);
  //   const location = window.location.href;
  //   this.disabled = location.includes('/distribution-center/dashboard') ||
  //     location.includes('/forward-stocking-location/dashboard') ||
  //     (location.includes('/forward-stocking-location/scorecard') && !location.includes('scorecard-details'));
  //   if (spinner && !this.disabled && !spinner.classList.contains('spin')) {
  //     spinner.classList.add('spin');
  //   }
  // }

  // hide(className: any) {
  //   document.querySelector(className).classList.remove('spin');
  // }
  // In your spinner.service.ts
show(className: any) {
  // Find the content container where the spinner should appear
  const contentContainer = document.querySelector('.main-content-area'); // Update this selector to match your app's content area
  
  if (contentContainer) {
    // Find or create spinner
    let spinner = contentContainer.querySelector('.ups-truck-spinner-container');
    
    if (!spinner) {
      // If spinner doesn't exist in content area, create it
      spinner = document.createElement('div');
      spinner.className = 'ups-truck-spinner-container content-only';
      spinner.innerHTML = `
        <div class="ups-truck-spinner">
          <div class="truck-animation-container">
            <img src="assets/img/ups-truck.gif" alt="Loading..." width="120" class="ups-truck-image" />
          </div>
          <div class="loading-text">Loading...</div>
        </div>
      `;
      contentContainer.appendChild(spinner);
    }
    
    // Make spinner visible
    (spinner as HTMLElement).style.display = 'flex';
  }
}

hide(className: any) {
  // Find spinners in content area and hide them
  const contentContainer = document.querySelector('.main-content-area'); // Update this selector to match your app's content area
  
  if (contentContainer) {
    const spinner = contentContainer.querySelector('.ups-truck-spinner-container');
    if (spinner) {
      (spinner as HTMLElement).style.display = 'none';
    }
  }
}

  disable() {
    this.disabled = true;
  }

  enable() {
    this.disabled = false;
  }

}
